
<template>
  <div>      
    <div style="background-color:white; text-align: center;   display: flex;  justify-content: center;  align-items: center; height:100vh">                                                  
      <div class="content-center">            
        <div class="container">
          <div style="col-md-3 ml-auto mr-auto text-center">                                   
            <li
              v-for="(doc, index) in bookingdetails.synergize"
              class="libtn"
              @click="getDoc(doc.docid,doc.filetype, doc.doctype +'-'+ doc.filename)"
            >
              {{ index }} - {{ doc.doctype }}  - {{ doc.filename }}
            </li>           
          </div>                             
        </div>        
  
        <!-- popup -->
        <div :class="[isActive ? 'popup' : 'none']">              
          <div class="pCenter">                
            <ul>
              <li id="pTitle">
                Sign POD where clicked <button
                  id="downloadButton"
                  class="libtn"
                  @click="downloadPDF()"
                >
                  download PDF
                </button> <span
                  style="float:right"
                  class="pClose"
                  @click="close()"
                >❌</span>
              </li>                                 
            </ul>     

            <div class="pContent">                
              <div id="signatureContainer">
                <VueSignaturePad
                  id="signatureCapture"
                  ref="signaturePad"
                  width="480px"
                  height="150px"
                  :options="DEFAULT_OPTIONS"                                            
                />
                <div id="signatureButtons">
                  <button @click="clearSignature()">
                    Clear
                  </button>
                  <button @click="undoSignature()">
                    Undo
                  </button>
                  <button @click="acceptSignature()">
                    Accept
                  </button>
                </div>
              </div>                                                       
              <div
                id="imgCont"
                @click="signPDF($event)"
                @mousemove="getMousePosition"
              />                                                                                                                        
            </div>                   
          </div>
        </div>
      </div>  
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { jsPDF } from "jspdf";
import UTIF from 'utif'
import Button from '../../components/Button.vue';


export default {
  name: 'Bookingstatus',
  components: { Button },      
  data() {
    return { 
    isActive: true,
    signActive: false,
    bookingdetails: '',
    filename: '',
    pages: '',
    resp: '',
    file: '',
    type: '',
    POD: {
      name: '',
      data: '',
      width: '',
      height: '',
      signature: '',
      signed: '',
      xPos:'',
      yPos:''
    },
    DEFAULT_OPTIONS: {
      dotSize: 2,
      minWidth: 0.5,
      maxWidth: 2.5,
      throttle: 64,
      minDistance: 5,
      backgroundColor: 'rgba(0,0,0,0)',
      penColor: 'blue',
      velocityFilterWeight: .7,      
    }

   };
  },
  watch: {      
  },
  created() {        
    
  },  
  updated(){

  },
  mounted (){
    this.bookingStatus('LT943995');
  },
  methods: {
    clearSignature() {
      this.$refs.signaturePad.clearSignature();
    },
    undoSignature() {
      this.$refs.signaturePad.undoSignature();
    },
    acceptSignature () {
      //console.log(this.POD.data)
      //this.$refs.signaturePad.fromDataURL(this.POD.data);
            
      //console.log(this.POD.data)

      document.getElementById("imgCont").innerHTML ="";
      document.getElementById("signatureContainer").style.position = "fixed"; 
      document.getElementById("signatureContainer").style.left = "-200vw";                  

      this.POD.signature = this.$refs.signaturePad.saveSignature()
      //this.$refs.signaturePad.addImages("[{ src: '"+ this.POD.data +"', x: 0, y: 0 }]")
      
      this.$refs.signaturePad.addImages([{ src: this.POD.data , x: 0, y: 0 }]).then( result => {         
        /*            
        this.$refs.signaturePad.mergeImageAndSignature(result).then(merged =>{
          console.log(merged)

          const imgObj = document.createElement('img');       
          imgObj.className = 'POD';
          imgObj.src = merged;
          document.getElementById("imgCont").appendChild(imgObj);

        })
        */
        
        let el = document.getElementById("imgCont")
        let rect = el.getBoundingClientRect();

      
      // ************figure out proper math ***********************
        let s = this.$refs.signaturePad.saveSignature();
        console.log(s.data)
        let sig = {
          src: s.data, 
          x: this.POD.xPos,
          y: this.POD.yPos
        }
        console.log(sig)
        this.$refs.signaturePad.mergeImageAndSignature(sig).then(merged =>{
          console.log(merged)

          const imgObj = document.createElement('img');       
          imgObj.className = 'POD';
          imgObj.src = merged;
          document.getElementById("imgCont").appendChild(imgObj);

        })
              
      })


      console.log(this.POD.signed)
      //this.$refs.signaturePad.clearCacheImages();   

    },
    relDiff(a, b) {
      return  100 * Math.abs( ( a - b ) / ( (a+b)/2 ) );
    },  
    signPDF(event) {      

        /*
        // clientX/Y gives the coordinates relative to the viewport in CSS pixels.
        console.log(event.clientX);
        console.log(event.clientY);

        // pageX/Y gives the coordinates relative to the <html> element in CSS pixels.
        console.log(event.pageX);
        console.log(event.pageY);

        // screenX/Y gives the coordinates relative to the screen in device pixels.
        console.log(event.screenX);
        console.log(event.screenY);
        */
        let el = document.getElementById("imgCont")
        let rect = el.getBoundingClientRect();
        let x = event.clientX - rect.left;
        let y = event.clientY - rect.top;                

        //document.getElementById("signatureContainer").style.display = 'block';
        /*
        document.getElementById("signatureContainer").style.position = 'absolute';
        document.getElementById("signatureContainer").style.top = y +'px';
        document.getElementById("signatureContainer").style.left = x +'px';     
        */

        document.getElementById("signatureContainer").style.display = "flex"        
        document.getElementById("signatureContainer").style.flexDirection = "column"        
        document.getElementById("signatureContainer").style.justifyContent = "center"
        document.getElementById("signatureContainer").style.alignItems = "center"
        
        document.getElementById("signatureContainer").style.width = "100%"
        document.getElementById("signatureContainer").style.height = "80vh"
        document.getElementById("signatureContainer").style.top = "0px"
        document.getElementById("signatureContainer").style.left = "0px"

        document.getElementById("signatureButtons").style.display = "flex"            
        

                
        this.POD.xPos = this.map_range(x,0,rect.width,0,this.POD.width);
        this.POD.yPos = this.map_range(y,0,rect.height,0,this.POD.height);


        this.$refs.signaturePad.openSignaturePad()
    },    
    getMousePosition(event) {
            let rect = document.getElementById("imgCont").getBoundingClientRect();
            let x = event.clientX - rect.left;
            let y = event.clientY - rect.top;
            /*
            console.log("Coordinate x: " + x, 
                        "Coordinate y: " + y); 
            */
            var cordinates = "["+ this.POD.width +","+ this.POD.height +"]" + "["+ Math.round(rect.width) +","+ Math.round(rect.height) +"]" +   "X : " + x + "px , Y : " + y+ " px";                                
            var mapped = "X : " + this.map_range(x,0,rect.width,0,this.POD.width) + "px , Y : " + this.map_range(y,0,rect.height,0,this.POD.height) + " px";
            //document.getElementById("pTitle").innerHTML=cordinates+ ":" + mapped
            console.log(cordinates+ ":" + mapped)

    },  
    map_range(x, inMin, inMax, outMin, outMax) {
      return (x - inMin) * (outMax - outMin) / (inMax - inMin) + outMin;
    },      
    onBegin() {
      console.log('=== Begin ===');
    },
    onEnd() {
      console.log('=== End ===');
    },    
    close(){
      document.getElementById("signatureContainer").style.position = "fixed"; 
      document.getElementById("signatureContainer").style.left = "-200vw";  
      this.isActive = false;    
    },
    getDoc(id,type,fn) {        
      try {                

        this.isActive = true;
        this.filename = fn;      

        this.filename = this.filename.replace('Synergize Bulk Print','TransPlus')
        this.filename = this.filename.replace('Proof of Delivery','POD')

        if (this.isActive){
          document.getElementById("imgCont").innerHTML = '';
          let vm = this  
          axios.post('https://api.transplus.com/getDoc/', {docid : id, filetype: type})
          .then((file) => {
            console.log (file)
            vm.LoadImg(file.data); 
          })
          .catch(e => {
            console.log(e)
          }) 
        }   
      }catch(err){
        console.log('hello');
      }

    },    
    _base64ToArrayBuffer(base64) {
      var binary_string = window.atob(base64);
      var len = binary_string.length;
      var bytes = new Uint8Array(len);
      for (var i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
      }
      return bytes.buffer;
    },
    downloadPDF(){
      let vm = this
      document.getElementById('downloadButton').innerHTML = 'processing...'
            
      setTimeout(function(){
        const doc = new jsPDF({compress: true});      
        var img = document.querySelectorAll("div#imgCont img");
        var counter=0;
        img.forEach(img => {        
          if (counter > 0) doc.addPage();
          doc.addImage(img.getAttribute("src"), "PNG", 0, 0, 210,  300)         
          counter++;
        });
        doc.save(vm.filename +'.pdf', {returnPromise: true}).then( () => { 
          console.log('download complete') 
          document.getElementById('downloadButton').innerHTML = 'download PDF'
        });         
      },500)           
      
    },
    LoadImg(img) {		         
      //const doc = new jsPDF();    
      this.resp = this._base64ToArrayBuffer(img); //Tif File Array Buffer
      this.pages = UTIF.decode(this.resp);
		  console.log(this.pages);
      console.log('page count: ' + this.pages.length);                 

      for (let p =0; p < this.pages.length; p++){
        try {
          UTIF.decodeImage(this.resp, this.pages[p]);
          const rgba = UTIF.toRGBA8(this.pages[p]); // Uint8Array with RGBA pixels

          const canvas = document.createElement('canvas');
          canvas.width = this.pages[p].width;
          canvas.height = this.pages[p].height;
          
          this.POD.width = this.pages[p].width;
          this.POD.height = this.pages[p].height;

          const ctx = canvas.getContext('2d');
          const imageData = ctx.createImageData(canvas.width, canvas.height);
          for (let i = 0; i < rgba.length; i++) {            
            imageData.data[i] = rgba[i];
          }        
          ctx.putImageData(imageData, 0, 0);          

          const imgObj = document.createElement('img');       
          imgObj.className = 'POD';
          imgObj.src = canvas.toDataURL('image/png');

          // for test prupose only: save dataurl in vue variable : in loop so only last saved --------------
          
          this.POD.name = this.filename
          this.POD.data = canvas.toDataURL('image/png');                        
          //-------------------------------------------------------------------------------------------------

          imgObj.setAttribute('width', canvas.width );        
          //imgObj.setAttribute('height', 1980 );        

          //doc.addPage();
          //doc.addImage(canvas.toDataURL('image/png'), "PNG", 0, 0, canvas.width, canvas.height)
          document.getElementById("imgCont").appendChild(imgObj);
        }catch(e){
          console.log(e);
        }

        //show download button
        document.getElementById("download").style.display = 'inline';

      }
      //doc.save('test.pdf'); 
      
    },    
    removeByClassName(className){
            //remove images
      const elements = document.getElementsByClassName(className);
      while(elements.length > 0){
          elements[0].parentNode.removeChild(elements[0]);
      }
    },   
    bookingStatus (bn){        
        let vm = this                       
        this.isActive = false        
        axios.get('https://api.transplus.com/bookingstatusV2/' + bn.toUpperCase ())
        .then((response) => {
          
          console.log(response)                    
          vm.bookingdetails = response.data[0]                 
    
          
        })
        .catch(e => {
          console.log(e)
        })
        
    }    
  }
}
</script>

<style lang="scss" scoped>


.libtn, .liSign {
  border-radius: 5px;
  padding:3px;
  padding-left:15px;
  padding-right:15px;
  margin:3px;
  background-color:grey;
  color:azure;
  list-style: none;
}
.libtn:hover {
  cursor: pointer;
  background-color:#55B550;
}


.none{
  display:none;
}

.popup{
  position: fixed;
  z-index: 99999;
  top:0;
  left:0;
  width:100%;
  height:100%;  
  background-color: rgba(0,0,0,0.5);  
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;  
}
.pCenter{
    margin: 0px;
    background-color: rgba(0,0,0,0.5);    
    position: absolute;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
    width:80vw;
    height:80vh;    
    border-radius:10px;
    overflow: hidden;
}
.pClose {
  cursor: pointer;
  padding-top:5px;
  padding-right:5px;  
  transition: all 100ms;
  font-size:1.2em;
  font-weight: bold;
  text-decoration: none;
  color: #ff0000;
  filter: brightness(1000%);
  &:hover {
    filter: brightness(100%);
  }
}
.pContent{
  /*max-height: 400px;*/
  position:relative;
  height:100%;
  overflow: auto;    
}   

.pCenter ul {
  list-style-type: none;
  margin: 0px;  
  padding: 4px;
}

.pCenter li {  
  color:white;
}

.pCenter li a {
  display: block;
  color: white;
  text-align: center;
  padding: 20px 0px;
  text-decoration: none;
}

#signatureButtons{
  margin-top:20px;
}

#signatureContainer{
  position: fixed; 
  left: -200vw;
  background-color: rgba(0,0,0,.75);
  padding:10px;
  border-radius: 5px;  
}

#signatureCapture {    
  border: dotted 3px transparent;
  border-radius: 5px;
  border-color:black;
  background-color:rgba(255,255,255,0.75);
  
  background-origin: border-box;
  background-clip: content-box, border-box;
}
</style>